/**
 * @author James Adams
 */
function CrewState(id){
  this.createCachedPageState(id,{
    name:"",
    credits:400,
    captain:null,
    firstMate:null,
    soldiers:[],
    confirmDisplay:"closed",
    confirmMessage:"",
    sort:[],
    filter:{},
    columnView:{},
    columnOrder:[],
    errorMessage:"",
    selection:[],
    version1:"1"
  },
  [
    "name",
    "credits",
    "captain",
    "firstMate",
    "soldiers",
    "sort",
    "filter",
    "columnView",
    "columnOrder",
    "version1"
  ]);
}

export default CrewState;
